<template>
  <modal :titulo="titulo" class="modal-consulta" :class="classe" :justify-end="justifyEnd" :focus="false">

    <template #actions>

      <slot name="cabecalho"></slot>

      <li class="list-inline-item" v-if="hasFiltros && show">
        <a @click.prevent="changeFiltro()" title="Filtrar Consulta" href>
          FILTROS DA CONSULTA
          <i class="pointer far" :class="{'fa-angle-up' : filtros, 'fa-angle-down' : !filtros}"></i>
        </a>
      </li>

    </template>

    <card chave="principal" titulo="Filtrar Consulta" key="principal" class="filtros-consulta" v-if="mostrarFiltros">
      <card-content >
        <form @submit.prevent @keyup.enter="executeLoad()" class="row gutters-xs">

          <slot name="filtros"></slot>

        </form>
      </card-content>
    </card>

    <card :titulo="paginationTitulo" class="card" id="table-pagination" v-if="mostrarTabela" :style="{'min-width': minWidth || '800px', 'overflow': 'hidden'}">
      <template #acoes>
        <slot name="acoes"></slot>
      </template>
      <div v-dragscroll="this.draggable" class="card-table table-borderless" :class="{loading : loading, 'cursor-grab': grabbable}" style="overflow: auto;">

        <async-table :columns="columns" :pagination="process" class="table table-card" :class="{'table-striped': !semStriped}"
                     @paginated="paginated"
                     :name="'pagination-'+this.name" :delayed="true" ref="paginator">

          <template #row="{ row }">
            <slot name="row" :row="row"></slot>
          </template>
          <template #rowExtra>
            <slot name="rowExtra"></slot>
          </template>

          <template #empty>
            <tr>
              <td colspan="100% p-0">
                <div class="alert alert-outline-info">{{ labelListaVazia }}</div>
              </td>
            </tr>
          </template>

        </async-table>

      </div>

      <async-pager :name="'pagination-'+this.name" />

    </card>

    <template #footer>

      <v-button v-if="actions.length" :actions="actions" :button="false" :list="true" :popover="true" :showLoading="false"
                class="btn btn-xs btn-outline-info pointer mr-2" label="" position="dropup" title="Ver Ações">
        <i class="fas fa-bars"></i>
      </v-button>

      <slot name="footer"></slot>

      <v-button v-if="mostrarFiltros && limparFiltro"
                :class="{'ml-auto' : mlAuto, 'ml-2' : !mlAuto}"
                class="btn btn-outline-secondary"
                data-testid="limpar"
                :popover="true"
                :run="limpar">
        Limpar Filtros
      </v-button>

      <button v-if="mostrarFiltros" :class="{'ml-auto' : mlAuto && !limparFiltro, 'ml-2' : !mlAuto || limparFiltro}"  class="btn btn-outline-primary" data-testid="filtrar" type="button"
              @click.prevent="load()">
        Filtrar
      </button>
    </template>

  </modal>

</template>

<script>
import FrontBusiness from "@/business/FrontBusiness";
import EventBus from "@/commons/EventBus.js";
import utils from "@/commons/Utils";
import AjudaConsultas from "@/components/Consultas/AjudaConsultas.vue";
import Card from "@/components/Layout/components/Card.vue";
import CardContent from "@/components/Layout/components/CardContent.vue";
import Modal from "@/components/Modal";
import AsyncPager from "@/components/Table/AsyncPager.vue";
import AsyncTable from "@/components/Table/AsyncTable.vue";
import ExportUtils from "@/commons/ExportUtils";

export default {
    name: "Consulta",
    components: {Card, CardContent, AsyncTable, AsyncPager, Modal},

    props: {
      columns: Array,
      process: Function,
      titulo: String,
      paginationTitulo: String,
      grabbable: Boolean,
      minWidth: String,
      perPage: String,
      stopLoad: Boolean,
      draggable: {type : Boolean, default : true},
      filtrosValidos : {type : Boolean, default : true},
      mlAuto : {type : Boolean, default : true},
      classe: {type: String, default: ''},
      semStriped : {type : Boolean, default : false},
      labelListaVazia: {type: String, default: 'Nenhum registro encontrado'},
      justifyEnd: {type : Boolean, default : false},
      salvarFiltros: {type : Boolean, default : true},
      exportar: {type : Object, default: () => {}},
      customActions: {type : Array, default: () => []},
    },

    modal: {
      width: 1300,
      escapable: false
    },

    data() {
      return {
        loading: false,
        name: utils.uuid(),
        total: 0,
        show: false,
        filtros: true,
        filtroInicial: null,
        event: 'CONSULTA-LOAD'
      }
    },

    computed: {
      hasFiltros() {
        return !!this.$slots.filtros;
      },
      mostrarFiltros(){
        return this.hasFiltros && this.filtros;
      },
      mostrarTabela(){
        return !this.mostrarFiltros && this.show;
      },

      limparFiltro() {
        return this.salvarFiltros // && this.filtroInicial;
      },
      actions(){
        let actions = [];
        if (!this.$root.isVhlUser && this.exportar?.id) {
          actions.push({
            class: 'at-options',
            icon: 'far fa-file-excel mr-1',
            label: 'Exportar XLS',
            action: this.exportarRelatorio
          });
          actions.push({
            class: 'at-options',
            icon: 'far fa-eye mr-1',
            label: 'Ver Relatórios Gerados',
            action: this.openRelatorio
          });
        }
        if (this.customActions.length) actions = [...actions, ...this.customActions]
        actions?.forEach((a,i) => {
          if(i != actions.length - 1) a.class += ' at-bbottom';
        });
        return actions
      },
    },

    mounted() {
      if (this.salvarFiltros && this.hasFiltros) {
        let filtrosSalvos = localStorage.getItem(this.id());
        this.filtroInicial = {mode: utils.clone(this.$parent.mode), filtros: utils.clone(this.$parent.filtros)};
        if (filtrosSalvos) {
          let filtros = JSON.parse(filtrosSalvos);
          if(!(this.$root.config.geral.desativarModeloAntigo && filtros.mode == 'default')) {
            this.$parent.filtros = filtros.filtros;
            this.$parent.mode = filtros.mode;
          }
        }
      }
      EventBus.$on(this.event, this.load);
    },

    beforeDestroy() {
      EventBus.$off(this.event, this.load);
    },

    methods: {

      id() {
        var MD5 = function(d){var r = M(V(Y(X(d),8*d.length)));return r.toLowerCase()};function M(d){for(var _,m="0123456789ABCDEF",f="",r=0;r<d.length;r++)_=d.charCodeAt(r),f+=m.charAt(_>>>4&15)+m.charAt(15&_);return f}function X(d){for(var _=Array(d.length>>2),m=0;m<_.length;m++)_[m]=0;for(m=0;m<8*d.length;m+=8)_[m>>5]|=(255&d.charCodeAt(m/8))<<m%32;return _}function V(d){for(var _="",m=0;m<32*d.length;m+=8)_+=String.fromCharCode(d[m>>5]>>>m%32&255);return _}function Y(d,_){d[_>>5]|=128<<_%32,d[14+(_+64>>>9<<4)]=_;for(var m=1732584193,f=-271733879,r=-1732584194,i=271733878,n=0;n<d.length;n+=16){var h=m,t=f,g=r,e=i;f=md5_ii(f=md5_ii(f=md5_ii(f=md5_ii(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_ff(f=md5_ff(f=md5_ff(f=md5_ff(f,r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+0],7,-680876936),f,r,d[n+1],12,-389564586),m,f,d[n+2],17,606105819),i,m,d[n+3],22,-1044525330),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+4],7,-176418897),f,r,d[n+5],12,1200080426),m,f,d[n+6],17,-1473231341),i,m,d[n+7],22,-45705983),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+8],7,1770035416),f,r,d[n+9],12,-1958414417),m,f,d[n+10],17,-42063),i,m,d[n+11],22,-1990404162),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+12],7,1804603682),f,r,d[n+13],12,-40341101),m,f,d[n+14],17,-1502002290),i,m,d[n+15],22,1236535329),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+1],5,-165796510),f,r,d[n+6],9,-1069501632),m,f,d[n+11],14,643717713),i,m,d[n+0],20,-373897302),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+5],5,-701558691),f,r,d[n+10],9,38016083),m,f,d[n+15],14,-660478335),i,m,d[n+4],20,-405537848),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+9],5,568446438),f,r,d[n+14],9,-1019803690),m,f,d[n+3],14,-187363961),i,m,d[n+8],20,1163531501),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+13],5,-1444681467),f,r,d[n+2],9,-51403784),m,f,d[n+7],14,1735328473),i,m,d[n+12],20,-1926607734),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+5],4,-378558),f,r,d[n+8],11,-2022574463),m,f,d[n+11],16,1839030562),i,m,d[n+14],23,-35309556),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+1],4,-1530992060),f,r,d[n+4],11,1272893353),m,f,d[n+7],16,-155497632),i,m,d[n+10],23,-1094730640),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+13],4,681279174),f,r,d[n+0],11,-358537222),m,f,d[n+3],16,-722521979),i,m,d[n+6],23,76029189),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+9],4,-640364487),f,r,d[n+12],11,-421815835),m,f,d[n+15],16,530742520),i,m,d[n+2],23,-995338651),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+0],6,-198630844),f,r,d[n+7],10,1126891415),m,f,d[n+14],15,-1416354905),i,m,d[n+5],21,-57434055),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+12],6,1700485571),f,r,d[n+3],10,-1894986606),m,f,d[n+10],15,-1051523),i,m,d[n+1],21,-2054922799),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+8],6,1873313359),f,r,d[n+15],10,-30611744),m,f,d[n+6],15,-1560198380),i,m,d[n+13],21,1309151649),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+4],6,-145523070),f,r,d[n+11],10,-1120210379),m,f,d[n+2],15,718787259),i,m,d[n+9],21,-343485551),m=safe_add(m,h),f=safe_add(f,t),r=safe_add(r,g),i=safe_add(i,e)}return Array(m,f,r,i)}function md5_cmn(d,_,m,f,r,i){return safe_add(bit_rol(safe_add(safe_add(_,d),safe_add(f,i)),r),m)}function md5_ff(d,_,m,f,r,i,n){return md5_cmn(_&m|~_&f,d,_,r,i,n)}function md5_gg(d,_,m,f,r,i,n){return md5_cmn(_&f|m&~f,d,_,r,i,n)}function md5_hh(d,_,m,f,r,i,n){return md5_cmn(_^m^f,d,_,r,i,n)}function md5_ii(d,_,m,f,r,i,n){return md5_cmn(m^(_|~f),d,_,r,i,n)}function safe_add(d,_){var m=(65535&d)+(65535&_);return(d>>16)+(_>>16)+(m>>16)<<16|65535&m}function bit_rol(d,_){return d<<_|d>>>32-_}
        let id = this.$parent.titulo || (this.$parent.$el.innerText || '').split("\n")[0];
        return MD5(id);
      },

      changeFiltro(){
        if(this.show) this.filtros = !this.filtros;
        if(this.mostrarTabela){
          this.fLoad();
        }
        this.$emit('botao-filtrar-clicado');
      },

      setFiltros(isFiltro) {
        this.filtros = isFiltro;
      },

      async getData(sort_by, sort_dir, page_length, page_number) {
        return this.process(sort_by, sort_dir, page_length, page_number);
      },

      async executeLoad(){
        await FrontBusiness.sleep(1000);
        if(!this.stopLoad){
          this.load()
        }
      },

      limpar() {
        if (!this.filtroInicial) return;
        this.$parent.filtros = this.filtroInicial.filtros;
        this.$parent.mode = this.filtroInicial.mode;
        this.$parent.$forceUpdate();
        localStorage.removeItem(this.id());
      },

      load() {
        if (!this.filtrosValidos) return;
        this.saveFiltros();
        setTimeout(() => this.fLoad(), this.$parent.armazenarFiltro ? 500 : 0);
      },

      saveFiltros() {
        if (!(this.salvarFiltros && this.hasFiltros)) return
        let obj = utils.clone(this.$parent.filtros);
        Object.keys(obj).forEach(key => {
          if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
            delete obj[key];
          }
        });
        obj.filtros = (obj?.filtros || []).filter(e => !utils.isEmptyNullOrUndefined(e.value)
          || !utils.isEmptyNullOrUndefined(e.startDate)
          || !utils.isEmptyNullOrUndefined(e.endDate));
        localStorage.setItem(this.id(), JSON.stringify({mode: this.$parent.mode, filtros: obj}));
      },

      fLoad(){
        if(this.$parent.armazenarFiltro) {
          this.$parent.armazenarFiltro();
        }
        this.show = true;
        this.filtros = false;
        this.$nextTick(() => {
          this.$refs.paginator.paginar(1);
          this.$parent.chequesSelecionados = [];
        });
      },

      paginated(page){
        //page = {rows, totalRows}
        this.$emit('paginated', page);
      },

      formatarCodigo: FrontBusiness.formatarCodigo,

      dicasBusca(modulo){
        FrontBusiness.openModal(AjudaConsultas, {modulo})
      },

      async exportarRelatorio() {
        await ExportUtils.exportarRelatorio(this.exportar)
      },

      openRelatorio(params = {}) {
        ExportUtils.openRelatorio()
      }

    }
  }
</script>

<style lang=scss>

  .modal-consulta.modal-content {

    .modal-body{
      max-height: unset;
    }

    #table-pagination {

      table {

        /*table-layout: fixed;*/
        thead {

          th {

            & > {

              span:first-child {
                float: left;
                line-height: 16px;
                height: 19px;
                white-space: nowrap;
                overflow: hidden;
                display: block;
                text-overflow: ellipsis;
                width: calc(100% - 22px);
              }

            }

            &.sortable > {

              span:last-child {
                cursor: pointer;
                float: right;
                width: 100%;
                text-align: right;
                margin-top: -15px;
                padding: 5px 5px 0;

                &.fa-sort-up, &.fa-sort-down {
                  color: #333;
                }
              }

            }

          }

        }

      }

      .loading tbody {
        display: none;
      }

    }
    .dropdown-menu {
      border-right: 5px solid #f48a06;
      border-left: 5px solid #f48a06;
      border-top: 1px solid rgba(52, 152, 219, 0.75);
      border-bottom: 1px solid rgba(52, 152, 219, 0.75);
      width: max-content;
      box-shadow: 0px 2px 8px 2px #000;
      margin-top: 0.5rem;
      font-weight: 500 !important;
      height: fit-content;

      .at-options {
        padding: 0.5rem !important;
      }

      i {
        width: 15px;
        text-align: center;
      }

      .at-bbottom {
        border-bottom: 0.5px solid rgba(216, 213, 213, 0.75);
      }
    }
  }

</style>
